import { baseURL } from "@/general";
import axios from "axios";

const adminApi = axios.create({
  baseURL,
});

export const getSemestresService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("/semestre/semestres", config);
    return response;
  } catch (error) {
    let response = error.response
      ? error.response
      : { replyCode: 500, replyText: error.message };
    return response;
  }
};

export const insertSemestreService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("/semestre/insert", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updateSemestreService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("/semestre/update", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getCurrentSemestreService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("/semestre/semestreActual", config);
    return response;
  } catch (error) {
    let response = error.response
      ? error.response
      : { replyCode: 500, replyText: error.message };
    return response;
  }
};

export const getCurrentPeriodoService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get("/periodo/periodoActual", config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getPeriodosService = async (values) => {
  let token = sessionStorage.getItem("token");
  let idSemestre = sessionStorage.getItem("idSemestre");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get(
      `/periodo/periodos/${idSemestre}`,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getBecasDisponiblesService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.get(`/catalogo/becasDisponibles`, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const insertPeriodoService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("/periodo/insert", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const updatePeriodoService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post("/periodo/update", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getRegistrosBySemestreService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "/registro/registrosBySemestre",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const acceptRegisterService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "/registro/aceptarRegistro",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const validateDocumentsService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "/alumno/validarDocumentacion",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const getRegistroDetailService = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "/registro/getInformacionRegistro",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// REPORTES
export const reporteSolicitudesRegistradas = async (values) => {
  let token = sessionStorage.getItem("token");
  const config = { headers: { "x-api-key": token } };
  try {
    const response = await adminApi.post(
      "/reporte/registrosPorSemestre",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

/* Servicio para verificar foto del registro */
export const getFotoAlumno = async (url) => {
  try {
    const response = await axios.get(url);
    if (!response.status == 200) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};
